import React, { useEffect } from 'react'
import CommonBanner from '../Common/CommonBanner'
import banner from "../../Assets/images/widerrufsrecht-banner.webp";
import { useDispatch } from 'react-redux';
import { setHeaderColor, setloading } from '../../Redux/ActionCreater';
import { Link } from 'react-router-dom';
const Widerrufsrecht = () => {
  let dispatch = useDispatch()
    const handleDownload = (e) => {
    e.preventDefault();
    let filename = "WIDERRUFSFORMULAR.pdf";
    let fileUrl ='https://d25wmlb2xnik84.cloudfront.net/frontend/WIDERRUFSFORMULAR_ShapebySarahHarrison_DE.pdf';

  
    const a = document.createElement("a");
    a.href = fileUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  };
  useEffect(() => {
    dispatch(setHeaderColor("#facee1"));
    window.scrollTo(0, 0);
    dispatch(setloading(false));
  }, [])
  return (
    <div>
      <CommonBanner slug={"widerrufsrecht"}  />
      <section class="toppara impressumcontainer">
        <div class="container">
          <div className="row">
            <div className="col-12">
              <h4>Widerrufsrecht</h4>
              <p>Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen</p>
              <p>Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag, an dem Sie oder ein von Ihnen benannter Dritter, der nicht der Beförderer ist, die Waren in Besitz genommen haben bzw. hat.</p>
              <p>Im Falle eines Vertrags über mehrere Waren, die Sie im Rahmen einer einheitlichen Bestellung bestellt haben und die getrennt geliefert werden, beträgt die Widerrufsfrist vierzehn Tage ab dem Tag, an dem Sie oder ein von Ihnen benannter Dritter, der nicht der Beförderer ist, die letzte Ware in Besitz genommen haben bzw. hat.</p>
              <p>Im Falle eines Vertrags über die Lieferung einer Ware in mehreren Teilsendungen oder Stücken beträgt die Widerrufsfrist vierzehn Tage ab dem Tag, an dem Sie oder ein von Ihnen benannter Dritter, der nicht der Beförderer ist, die letzte Teilsendung oder das letzte Stück in Besitz genommen haben bzw. hat.</p>
              <p>Um Ihr Widerrufsrecht auszuüben, müssen Sie uns:</p>
              <p>SHAPE BY SARAH ECOMMERCE - FZCO <br></br>Dubai Silicon Oasis, <br></br>DDP, Building A1/A2 <br></br>Dubai, United Arab Emirates</p>
              <p>E-Mail: <a href="mailto:support@shapebysarah.com">support@shapebysarah.com</a></p>
              <p>Telefon: <a href="tel:+49 170 6794214">+49 170 6794214</a></p>

              <p>mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter Brief oder eine E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür das beigefügte <Link onClick={handleDownload} to={'/WIDERRUFSFORMULAR'}>Muster-Widerrufsformular</Link> verwenden, das jedoch nicht vorgeschrieben ist.</p>

              <p>Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.</p>

              <h4>Folgen des Widerrufs</h4>
              <p>Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie eine andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt haben), unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet. Wir können die Rückzahlung verweigern, bis wir die Waren wieder zurückerhalten haben oder bis Sie den Nachweis erbracht haben, dass Sie die Waren zurückgesandt haben, je nachdem, welches der frühere Zeitpunkt ist.</p>
              <p>Sie haben die Waren unverzüglich und in jedem Fall spätestens binnen vierzehn Tagen ab dem Tag, an dem Sie uns über den Widerruf dieses Vertrags unterrichten, an:</p>
              <p>PVS eBusiness-Services GmbH <br></br>c/o Shape by Sarah Ecommerce - FZCO <br></br>Schleißheimer Strasse 93a <br></br>85748 Garching, Deutschland</p>
              <p>zurückzusenden oder zu übergeben. Die Frist ist gewahrt, wenn Sie die Waren vor Ablauf der Frist von vierzehn Tagen absenden.</p>
              <p>Sie tragen die unmittelbaren Kosten der Rücksendung der Waren..
                Sie müssen für einen etwaigen Wertverlust der Waren nur aufkommen, wenn dieser Wertverlust auf einen zur Prüfung der Beschaffenheit, Eigenschaften und Funktionsweise der Waren nicht notwendigen Umgang mit ihnen zurückzuführen ist.</p>

            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Widerrufsrecht